<template>
    <App />
</template>

<script setup lang="ts">
    import App from "@/App.vue"
    import { provideAuth0 } from "@/Services/Auth0/auth0-plugin";
    /* eslint-disable */
    provideAuth0();
</script>